export function getOptOutErrorLink() {
  return "https://learnersupport.vitalsource.com/hc/en-us/articles/35937863236247-Opt-out-Error-Messages";
}

export function submitVitalSourceSupport() {
  return "https://bookshelfsupport.vitalsource.com/hc/en-us/requests/new";
}

export function getVirtualBookstoreSupportLink() {
  return "https://onlinebookstoresupport.vitalsource.com/hc/en-us";
}
